import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {ComponentAsElement} from "../../services/common/bootstrap/annotation/component-as-element";
import {FramesSizeFilter} from "../../model/enums/Facets.enum";
import {Observable} from "rxjs";
import {ListingService} from "../../services/listing.service";
declare const window: any;

@ComponentAsElement('v-frames-size-filter-element')
@Component({
  selector: 'v-frames-size-filter',
  templateUrl: './frames-size-filter.component.html'
})
export class FramesSizeFilterComponent implements OnInit {
  @Input() themePath: string;
  @Input() facets;
  @Input() breakpoint$: Observable<string>;
  @Input() processing: boolean;
  @Output() submitFacets: EventEmitter<boolean> = new EventEmitter();
  noseName: string;
  noseValues: number[];
  framesName: string;
  framesValues: number[];
  lensesName: string;
  lensesValues: number[];
  frame: string;
  lense: string;
  nose: string;
  errorFrame = false;
  errorNoseLense = false;
  activePanel = 'noseLense';
  tolerance = 0;
  contentVisible = false;
  public lensesImg = 'filter-size-lenses.png';
  public framesImg = 'filter-size-frames.png';

  constructor(private listingService: ListingService) {
  }

  ngOnInit() {
    this.noseName = this.facets[FramesSizeFilter.noseSize]?.webname || null;
    this.noseValues = this.facets[FramesSizeFilter.noseSize]?.values.map(value => parseInt(value.code)) || null;
    this.framesName = this.facets[FramesSizeFilter.framesSize]?.webname || null;
    this.framesValues = this.facets[FramesSizeFilter.framesSize]?.values.map(value => parseInt(value.code)) || null;
    this.lensesName = this.facets[FramesSizeFilter.lensWidth]?.webname || null;
    this.lensesValues = this.facets[FramesSizeFilter.lensWidth]?.values.map(value => parseInt(value.code)) || null;
    this.tolerance = window.sizeFilterTolerance || 0;

    this.breakpoint$.subscribe(breakpoint => {
      const mobile = breakpoint === 'mobile';

      if(mobile) {
        this.contentVisible = false;
        this.lensesImg = 'filter-size-lenses.png';
        this.framesImg = 'filter-size-frames.png';
      } else {
        this.contentVisible = true;
        this.lensesImg = 'filter-size-lenses-gray.png';
        this.framesImg = 'filter-size-frames-gray.png';
      }
    });
  }

  ngOnChanges() {
    this.resetFields()
  }

  validateFrame(_target) {
    const val = _target.value;

    if(val) {
      this.errorFrame = false;
    }
  }

  validateNoseLense(_target) {
    const val = _target.value;

    if(val) {
      this.errorNoseLense = false;
    }
  }

  calcTolerantedValues(_typeToCalc) {
    const {val, values, tolerance, key, keyName} = _typeToCalc;
    let result = {};

    values.filter(value => value > 0 && value >= (val - tolerance) && value <= (val + tolerance) && value !== val)
                   .forEach(value => (result[`${keyName}-${value}`] = {key, value: `${value}`}))
    return result;
  }

  resetFields() {
    this.frame = '';
    this.nose = '';
    this.lense = '';
  }

  newSearch(_type) {
    const type = _type;
    let selected = {};

    switch (type) {
      case 'frame':
        if(!this.frame) {
          this.errorFrame = true;
          return;
        } else {
          const value = this.frame;
          const values =  this.framesValues;
          const sizeType = FramesSizeFilter.framesSize;
          const sizeName = this.framesName;

          this.listingService.removeFrameSize(sizeType);
          this.noseName && this.listingService.removeFrameSize(FramesSizeFilter.noseSize);
          this.lensesName && this.listingService.removeFrameSize(FramesSizeFilter.lensWidth);

          selected[`${sizeType}-${value}`] = {key: sizeName, value};
          this.tolerance > 0 && (selected = {...selected, ...this.calcTolerantedValues({val: +value, values, tolerance: this.tolerance, key: sizeName, keyName: sizeType})});
        }
        break;
      case 'noseLense':
        if(!this.nose && !this.lense) {
          this.errorNoseLense = true;
          return;
        } else {
          this.framesName && this.listingService.removeFrameSize(FramesSizeFilter.framesSize);

          if(this.nose) {
            const value = this.nose;
            const values =  this.noseValues;
            const sizeType = FramesSizeFilter.noseSize;
            const sizeName = this.noseName;

            this.listingService.removeFrameSize(sizeType);
            selected[`${sizeType}-${value}`] = {key: sizeName, value};
            this.tolerance > 0 && (selected = {...selected, ...this.calcTolerantedValues({val: +value, values, tolerance: this.tolerance, key: sizeName, keyName: sizeType})});
          }
          if(this.lense) {
            const value = this.lense;
            const values =  this.lensesValues
            const sizeType = FramesSizeFilter.lensWidth;
            const sizeName = this.lensesName;

            this.listingService.removeFrameSize(sizeType);
            selected[`${sizeType}-${value}`] = {key: sizeName, value};
            this.tolerance > 0 && (selected = {...selected, ...this.calcTolerantedValues({val: +value, values, tolerance: this.tolerance, key: sizeName, keyName: sizeType})});
          }
        }
        break;
    }

    this.submitFacets.emit(true);
    this.listingService.toggleFramesSize(selected);
    this.resetFields();
  }

  toggleContentVisibility() {
    this.contentVisible = !this.contentVisible;
  }
}
